import React from "react";
import DoctorHeader from "../components/header/DoctorHeader";
import DoctorSidebar from "../components/sidebar/DoctorSidebar";

const DoctorLayout = ({ children, noSidebar }) => {
  return (
    <div className="flex flex-col h-screen bg-[#F4FAF1]">
      {!noSidebar && <DoctorHeader />}
      <div className="flex flex-1 h-screen overflow-hidden">
        {!noSidebar && <DoctorSidebar />}
        <main className={"flex-1 overflow-y-auto" + `${noSidebar ? "" : " p-4 sm:ml-1"}`}>{children}</main>
      </div>
    </div >
  );
};

export default DoctorLayout;
